import { Component } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-main',
  template: `
    <div class="content-container">
      <div
        [ngClass]="{ 'content-area': dataService.url != '/login' }"
        class="content"
      >
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        flex: 1;
      }
      .content-container {
        width: 100%;
      }
    `,
  ],
})
export class MainComponent {
  constructor(public dataService: DataService) {}
}
